/* eslint-disable import/prefer-default-export */

import { ChatRoomType } from 'features/chat/types';

export type ReceiverType =
  | 'RECEIVER_TYPE_USER'
  | 'RECEIVER_TYPE_ROOM'
  | 'RECEIVER_TYPE_UNSPECIFIED';

interface ReceiverSchema {
  id: number;
  type: ReceiverType;
  name: string;
  avatar: string;
  shortName: string;
}

const transformReceiverType = (type: ChatRoomType): ReceiverType => {
  if (type === 'ROOM_TYPE_PERSONAL') {
    return 'RECEIVER_TYPE_USER';
  }
  if (type === 'ROOM_TYPE_GROUP') {
    return 'RECEIVER_TYPE_ROOM';
  }
  return 'RECEIVER_TYPE_UNSPECIFIED';
};

const transformRoomToReceiverSchema = (rooms): Array<ReceiverSchema> =>
  rooms.map((room) => ({
    id:
      room.type === 'ROOM_TYPE_PERSONAL'
        ? room.attributes?.personal?.user_id
        : room.id,
    type: transformReceiverType(room.type),
    name: room.info.name,
    avatar: room.info.avatar_url,
    shortName: room.info?.shortened_name,
  }));

const transformSearchToReceiverSchema = (result): Array<ReceiverSchema> =>
  result.map((item) => ({
    id: item.id,
    type: item.type,
    name: item.info.name,
    avatar: item.info.avatar_url,
    shortName: item.info?.shortened_name,
  }));

const transformReceiverPayload = (receivers) =>
  receivers.map(({ id, type }) => ({
    id,
    type,
  }));

export {
  transformRoomToReceiverSchema,
  transformSearchToReceiverSchema,
  transformReceiverPayload,
};
